import { eDonViHanhChinhActionsObj } from "../../action-types/category/IDonViHanhChinhActions";
import { generateActions } from "../generateActions";

export const donViHanhChinhActions = {
  ...generateActions(eDonViHanhChinhActionsObj, "DON_VI_HANH_CHINH"),
};
